<!-- 规格信息 -->
<template>
  <div class="business-info-view">
    <el-form
      :model="queryParams"
      :rules="rulesCompanyInfo"
      ref="BusinessInfoForm"
    >
      <p class="info-title">规格基础信息</p>

      <div class="business-info-block">
        <el-form-item
          label="规格说明文档名称："
          label-width="190px"
          prop="specDocName"
        >
          <el-input
            v-model="queryParams.specDocName"
            placeholder="请输入规格说明文档名称"
            style="width: 470px"
          />
        </el-form-item>

        <el-form-item
          label="文档最后更新时间："
          label-width="190px"
          prop="specLastUpdated"
        >
          <el-date-picker
            v-model="queryParams.specLastUpdated"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="文档版本号："
          label-width="190px"
          prop="specVersion"
        >
          <el-input
            v-model="queryParams.specVersion"
            disabled
            style="width: 470px"
          />
        </el-form-item>
      </div>

      <p class="info-title">功能规格</p>

      <div class="business-info-block">
        <!-- 功能规格 一级模块 -->
        <div
          class="each-data"
          v-for="(item, index) in queryParams.productFunctionalSpecList"
          :key="index"
        >
          <el-form-item label="功能模块：" label-width="190px">
            <el-input v-model="item.functionModule" style="width: 470px" />

            <span style="color: #4e93fb" @click="addOperateModule()">
              <i class="el-icon-circle-plus-outline"></i>
            </span>

            <span
              v-if="index > 0"
              style="color: #ff7575"
              @click="delOperateModule(index)"
            >
              <i class="el-icon-remove-outline"></i>
            </span>
          </el-form-item>

          <el-form-item label="功能描述：" label-width="190px">
            <el-input v-model="item.functionDescription" style="width: 470px" />
          </el-form-item>

          <div
            class="child-data"
            v-for="(childItem, childIndex) in item.subfunction"
            :key="childIndex"
          >
            <el-form-item label="子功能或子设备：" label-width="140px">
              <el-input v-model="childItem.name" style="width: 300px" />

              <span
                style="color: #4e93fb"
                @click="addChildOperateModule(index)"
              >
                <i class="el-icon-circle-plus-outline"></i>
              </span>

              <span
                v-if="childIndex > 0"
                style="color: #ff7575"
                @click="delChildOperateModule(index, childIndex)"
              >
                <i class="el-icon-remove-outline"></i>
              </span>
            </el-form-item>
          </div>
        </div>
      </div>

      <p class="info-title">技术规格</p>

      <div class="business-info-block">
        <!-- 技术规格 一级模块 -->
        <div
          class="each-data"
          v-for="(item, index) in queryParams.productTechnicalSpecList"
          :key="index"
        >
          <el-form-item label="参数类别：" label-width="190px">
            <el-input v-model="item.parameterClass" style="width: 470px" />

            <span style="color: #4e93fb" @click="addOperateTech()">
              <i class="el-icon-circle-plus-outline"></i>
            </span>

            <span
              v-if="index > 0"
              style="color: #ff7575"
              @click="delOperateTech(index)"
            >
              <i class="el-icon-remove-outline"></i>
            </span>
          </el-form-item>

          <el-form-item label="参数名称：" label-width="190px">
            <el-input v-model="item.parameterName" style="width: 470px" />
          </el-form-item>

          <el-form-item label="数据类型：" label-width="190px">
            <el-input v-model="item.dataType" style="width: 470px" />
          </el-form-item>

          <el-form-item label="参数内容：" label-width="190px">
            <el-input v-model="item.parameterContent" style="width: 470px" />
          </el-form-item>

          <el-form-item label="参数说明：" label-width="190px">
            <el-input
              v-model="item.parameterDescription"
              style="width: 470px"
            />
          </el-form-item>
        </div>
      </div>

      <p class="info-title">非功能规格</p>

      <div class="business-info-block">
        <div
          class="each-data"
          v-for="(item, index) in queryParams.noProductFunctionalSpecList"
          :key="index"
        >
          <el-form-item label="参数类别：" label-width="190px">
            <el-input v-model="item.parameterClass" style="width: 470px" />

            <span style="color: #4e93fb" @click="addNotOperateModule()">
              <i class="el-icon-circle-plus-outline"></i>
            </span>

            <span
              v-if="index > 0"
              style="color: #ff7575"
              @click="delNotOperateTech(index)"
            >
              <i class="el-icon-remove-outline"></i>
            </span>
          </el-form-item>

          <el-form-item label="参数名称：" label-width="190px">
            <el-input v-model="item.parameterName" style="width: 470px" />
          </el-form-item>

          <el-form-item label="数据类型：" label-width="190px">
            <el-input v-model="item.dataType" style="width: 470px" />
          </el-form-item>

          <el-form-item label="参数内容：" label-width="190px">
            <el-input v-model="item.parameterContent" style="width: 470px" />
          </el-form-item>

          <el-form-item label="参数说明：" label-width="190px">
            <el-input v-model="item.parameterDescription" style="width: 470px" />
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
// 功能规格数据模版
const tempModuleData = {
  functionDescription: "",
  functionModule: "",
  subfunction: [
    {
      // 子功能或子设备
      name: ""
    }
  ]
};

// 技术规格、非功能规格数据模版
const tempTechData = {
  dataType: "", // 数据类型
  parameterClass: "", // 参数类别
  parameterContent: "", // 参数内容
  parameterDescription: "", // 参数说明
  parameterName: "" // 参数名称
};

// api
import { getSpecification, updateSpecification } from "@/api/productClassify.js";

export default {
  components: {},
  data() {
    return {
      rulesCompanyInfo: {},
      queryParams: {
        specDocName: "",
        specLastUpdated: "",
        specVersion: "",
        // 功能规格
        productFunctionalSpecList: [
          {
            functionDescription: "", // 功能描述
            functionModule: "", // 功能模块
            subfunction: [
              {
                // 子功能或子设备
                name: ""
              }
            ]
          }
        ],
        // 技术规格
        productTechnicalSpecList: [
          {
            dataType: "", // 数据类型
            parameterClass: "", // 参数类别
            parameterContent: "", // 参数内容
            parameterDescription: "", // 参数说明
            parameterName: "", // 参数名称
            specificationType: 0
          }
        ],
        // 非功能规格
        noProductFunctionalSpecList: [
          {
            dataType: "", // 数据类型
            parameterClass: "", // 参数类别
            parameterContent: "", // 参数内容
            parameterDescription: "", // 参数说明
            parameterName: "", // 参数名称
            specificationType: 1
          }
        ]
      },
      isInit: false
    };
  },
  methods: {
    // 获取初始化数据
    getInfo() {
      if(this.isInit) {
        return void 0;
      }

      getSpecification({id: this.$route.query.productCode}).then(res => {
        if(res.code == 200 && res.data) {
          this.isInit = true;
          this.queryParams.specDocName = res.data.specDocName;
          this.queryParams.specLastUpdated = res.data.specLastUpdated;
          this.queryParams.specVersion = res.data.specVersion;
          this.queryParams.categoryCode = res.data.categoryCode;

          if(Array.isArray(res.data.productFunctionalSpecList) && 
          res.data.productFunctionalSpecList.length) {
            // 这一步用来防止二级数组类型问题
            res.data.productFunctionalSpecList.forEach(item => {
              item.subfunction = typeof item.subfunction === 'string' ? item.subfunction.split("^").map(item => {
                return {
                  name: item
                }
              }) : [{
                name: ""
              }];
            });

            this.queryParams.productFunctionalSpecList = res.data.productFunctionalSpecList;
          }

          if(Array.isArray(res.data.productTechnicalSpecList) 
          && res.data.productTechnicalSpecList.length) {
            // 技术规格
            let productTechnicalSpecList = res.data.productTechnicalSpecList.filter(item => {
              return item.specificationType == 0;
            });

            if(productTechnicalSpecList.length) {
              this.queryParams.productTechnicalSpecList = productTechnicalSpecList
            }
            
            // 非功能规格
            let noProductFunctionalSpecList = res.data.productTechnicalSpecList.filter(item => {
              return item.specificationType == 1;
            });

            if(noProductFunctionalSpecList.length) {
              this.queryParams.noProductFunctionalSpecList = noProductFunctionalSpecList;
            }
          }
        }
      })
    },
    submit() {
      let params = {
        // 解除双向绑定
        ...JSON.parse(JSON.stringify(this.queryParams)),
        productTechnicalSpecList: this.queryParams.productTechnicalSpecList.concat(
          this.queryParams.noProductFunctionalSpecList
        )
      }

      delete params.noProductFunctionalSpecList;
      // 处理第二集的数据结构
      if(Array.isArray(params.productFunctionalSpecList) && params.productFunctionalSpecList.length) {
        for(let i = 0; i < params.productFunctionalSpecList.length; i++) {
          const item = params.productFunctionalSpecList[i];

          if(Array.isArray(item.subfunction) && item.subfunction.length) {
            item.subfunction = item.subfunction.map(i => (i.name)).join("^")
          }
        }
      }

      this.$modal.loading('正在保存数据，请稍候...');

      updateSpecification(params).then(res => {
        if(res.code === 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    },
    // 功能规格
    addOperateModule() {
      this.queryParams.productFunctionalSpecList.push(
        JSON.parse(JSON.stringify(tempModuleData))
      );
    },
    delOperateModule(index) {
      this.queryParams.productFunctionalSpecList.splice(index, 1);
    },
    addChildOperateModule(index) {
      this.queryParams.productFunctionalSpecList[index]?.subfunction.push(
        JSON.parse(JSON.stringify({ name: "" }))
      );
    },
    delChildOperateModule(pIndex, index) {
      this.queryParams.productFunctionalSpecList[pIndex]?.subfunction.splice(
        index,
        1
      );
    },
    // 技术规格
    addOperateTech() {
      this.queryParams.productTechnicalSpecList.push(
        JSON.parse(JSON.stringify({ ...tempTechData, specificationType: 0 }))
      );
    },
    delOperateTech(index) {
      this.queryParams.productTechnicalSpecList.splice(index, 1);
    },
    // 非功能规格
    addNotOperateModule() {
      this.queryParams.noProductFunctionalSpecList.push(
        JSON.parse(JSON.stringify({ ...tempTechData, specificationType: 1 }))
      );
    },
    delNotOperateTech(index) {
      this.queryParams.noProductFunctionalSpecList.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.business-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  .tag {
    margin-left: 8px;
  }

  .input-radio-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
  }

  .business-honor-tags {
    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}

/deep/ .el-icon-circle-plus-outline {
  font-size: 31px;
  vertical-align: middle;
  color: #698eef;
  cursor: pointer;
  padding-left: 10px;
}

/deep/ .el-icon-remove-outline {
  font-size: 31px;
  vertical-align: middle;
  color: red;
  cursor: pointer;
  padding-left: 10px;
}

.child-data {
  width: 650px;
  padding: 10px 0;
  margin: 20px 0 20px 160px;
  border-radius: 4px;
}
</style>